import { memo } from 'react';
import { makeStyles, tokens } from '@fluentui/react-components';
import { Checkmark48Filled } from '@fluentui/react-icons';
import { useShowSubmitSuccess, useGridStore } from '../state';

const ENTER_MS = 400;
const HOLD_MS = 1000;
const EXIT_MS = 400;
const TOTAL_MS = ENTER_MS + HOLD_MS + EXIT_MS;

const enterPct = `${Math.round((ENTER_MS / TOTAL_MS) * 100)}%`;
const holdEndPct = `${Math.round(((ENTER_MS + HOLD_MS) / TOTAL_MS) * 100)}%`;

const useStyles = makeStyles({
    overlay: {
        position: 'absolute',
        inset: '0',
        display: 'flex',
        alignItems: 'flex-start',
        paddingTop: '15vh',
        justifyContent: 'center',
        pointerEvents: 'none',
        zIndex: 100,
        animationName: {
            from: { backdropFilter: 'blur(0px)' },
            [enterPct]: { backdropFilter: 'blur(2px)' },
            [holdEndPct]: { backdropFilter: 'blur(2px)' },
            to: { backdropFilter: 'blur(0px)' },
        },
        animationDuration: `${TOTAL_MS}ms`,
        animationTimingFunction: 'cubic-bezier(0.4, 0, 0.2, 1)',
        animationFillMode: 'both',
    },

    checkmark: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '96px',
        height: '96px',
        borderRadius: '50%',
        backgroundColor: tokens.colorStatusSuccessBackground3,
        color: tokens.colorNeutralForegroundOnBrand,
        animationName: {
            from: { opacity: 0, transform: 'scale(0.3)' },
            [enterPct]: { opacity: 1, transform: 'scale(1)' },
            [holdEndPct]: { opacity: 1, transform: 'scale(1)' },
            to: { opacity: 0, transform: 'scale(2)' },
        },
        animationDuration: `${TOTAL_MS}ms`,
        animationTimingFunction: 'cubic-bezier(0.4, 0, 0.2, 1)',
        animationFillMode: 'both',
    },

    icon: {
        fontSize: '48px',
        width: '48px',
        height: '48px',
    },
});

export const SubmitSuccessOverlay = memo(function SubmitSuccessOverlay() {
    const show = useShowSubmitSuccess();
    const styles = useStyles();

    if (!show) return null;

    return (
        <div className={styles.overlay} onAnimationEnd={() => useGridStore.getState().setShowSubmitSuccess(false)}>
            <div className={styles.checkmark}>
                <Checkmark48Filled className={styles.icon} />
            </div>
        </div>
    );
});
